import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Signed-in visitor's saved searches: load / add / remove. Redirects guests home.
export const useFavorites = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);

  const load = useCallback(() => {
    fetch(`${API}/api/favorites`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : []))
      .then(setFavorites)
      .catch(() => setFavorites([]));
  }, []);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate('/', { replace: true }); return; }
    load();
  }, [user, loading, navigate, load]);

  const add = async (value) => {
    await fetch(`${API}/api/favorites`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'search', label: value, value }),
    });
    load();
  };

  const remove = async (id) => {
    await fetch(`${API}/api/favorites/${id}`, { method: 'DELETE', credentials: 'include' });
    load();
  };

  const signOut = () => { logout(); navigate('/'); };
  return { user, pending: loading || !user, favorites, add, remove, signOut };
};
